import useGetAllWorkspaces from './useGetAllWorkspaces';

const useGetCurrentWorkspace = () => {
  const { currentWorkspace } = useGetAllWorkspaces();

  return currentWorkspace;
};

export default useGetCurrentWorkspace;
